export const mqttConfig = {
    hostname: 'wss://www.hexucloud.cn/websocket',
    port: 1883,
    clientId: 'hexu',
    username: 'admin',
    password: 'password',
    clean: true,
    connectTimeout: 10000,
}